<script>

import Layout from "../../layouts/main";
import DateRangePicker from "vue2-daterange-picker";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { supplierService } from "../../services";
import { date_ranges,debounce,success_message,error_message } from "../../Helper/helper";
import PurchasingPricesView from "./purchasing-prices-view.vue";
import Multiselect from "vue-multiselect";

export default {
  components: { DateRangePicker,Layout, PageHeader, pagination,PurchasingPricesView,Multiselect},
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Purchasing Price'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            config: config,
            products: [],
            showModal: false,
            supplierData: [],
            supplierId:'',
            producer_company : [],
            serachProduct : "",
            selectedSupplier: "",
            isLoading:false,
            searchData:debounce(()=>{
                if(!this.init){
                    const {orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'purchasing-price-list', query: {orderBy,sortBy}})
                }
                this.getSupllier();
                
                this.init = false;
            },500),
        };
    },
    computed: {
        productsWithDefault() {
            return [{ item_name: "Select Any Product", sub_product_id: null }, ...this.products];
        }
    },
    mounted() {
        this.getSupllier();
        this.getProducerCompany();
        this.asyncFindProduct({search: ""}).then(() => { 
            this.getSupllier();
        });
    },
    methods: {
        onRowClicked(item) {
            supplierService
            .getSupplierById({ id: this.base64(item.id) }).then((response) => {
                this.showModal = true;
                this.supplierData = response.data.result;
               
            });
        },
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getSupllier();
            this.getProducerCompany();
        },
        searchCompany() {
            // Pass the selected supplier and search term to filter the companies
            this.getProducerCompany(this.selectedSupplier);
            this.getProducerCompany();
        },
        getProducerCompany(supplierId) {
            this.loading = true;
            supplierService
            .getProducerCompany({id: supplierId})
            .then((response) => {
                this.loading = false;
                this.producer_company = response.data.result;
            });
            this.getSupllier({producer_company:supplierId});
        },
        getSupllier(page) {
            this.loading = true;
            if(this.serachProduct && this.serachProduct.sub_product_id == null){
                this.serachProduct = null
            }
            supplierService
            .getProductList({ 
                producer_company: this.selectedSupplier,
                serachProduct:this.serachProduct,
                search: this.search,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
            });
        },
        showSupplierDetails(id){
            supplierService
            .getProductList()
            .then((response) => {
                this.supplierData = response.data.result;
                this.subProductId = id;
                this.showModal = true;
            });
        },
        handleModalHidden() {
            this.showModal = false;
            this.getSupllier(); // Refresh the supplier list when the modal is hidden
        },
        handleProductSelection(product) {
            if (product.sub_product_id == null) {
                this.serachProduct = null; // Reset selected product
                this.getSupllier(); // Fetch all products
            } else {
                this.serachProduct = product; // Update with the selected product
                this.getSupllier(); // Trigger a search with the selected product
            }
        },
        async asyncFindProduct(query) {
            this.isLoading = true;
            try {
                const response = await supplierService.getAllProductByNameApi({ query });
                this.products = response.data.result;
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                this.isLoading = false;
            }
        },
    },
   
};
</script>

<template>
    <Layout>
        <div>
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                        <div class="page-title-left">
                            <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-user-circle"></i>
                            </span>
                            </div>
                            <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Purchasing Price') }}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row list-table-main">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-2 offset-sm-4">
                                    <div class="form-group">
                                        <div class="date-range-list">
                                            <label>{{ trans.get('__JSON__.Supplier') }} :</label>
                                            <select class="custom-select" v-model="selectedSupplier" @change="searchCompany">
                                                <option value="">{{ trans.get('__JSON__.All') }}</option>
                                                <option v-for="(pcom, index) in producer_company" :value="pcom.id" :key="`${pcom.id}-${index}`">{{pcom.producer_name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="date-range-list">
                                            <label>{{ trans.get('__JSON__.Product') }} :</label>
                                            <multiselect
                                                v-model="serachProduct"
                                                id="product"
                                                label="item_name"
                                                track-by="sub_product_id"
                                                :placeholder="trans.get('__JSON__.Type to Search Product')"
                                                open-direction="bottom"
                                                :options="productsWithDefault"
                                                :multiple="false"
                                                :searchable="true"
                                                :loading="isLoading"
                                                :internal-search="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :max-height="800"
                                                :show-no-results="true"
                                                :hide-selected="true"
                                                 @select="handleProductSelection"
                                                >
                                                <span slot="noResult">{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Search') }} :</label>
                                        <div class="text-sm-right">
                                            <div class="search-box mr-2 d-inline-block">
                                                <div class="position-relative">
                                                    <input
                                                    type="text"
                                                    class="form-control"
                                                    id="search"
                                                    @input="searchData()"
                                                    v-model="search"
                                                    :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                    />
                                                    <i class="bx bx-search-alt search-icon"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 table-main-list customer-table table-responsive">
                                    <table class="table table-centered table-nowrap table-hover table-main-border order-menu mt-0">
                                        <thead>
                                            <tr>
                                                <th>Product Name</th>
                                                <th>Supplier</th>
                                                <th>Purchasing Price</th>
                                                <th>Tax</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td>{{ item.item_name }}</td>
                                                <td>{{ item.producer_company_name }}</td>
                                                <td>{{ item.price_including_tax }} € / {{ item.price_excluding_tax }} €</td>
                                                <td>{{ item.tax }}</td>
                                                <td>
                                                    <button type="button" class="btn btn-primary btn-sm btn-rounded" @click="showSupplierDetails((item.sub_product_id))">View Details</button>
                                                </td>
                                            </tr>
                                            <tr v-if="!items.length">
                                                <td colspan="7" class="text-center">{{ trans.get('__JSON__.No Purchasing Price') }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row col-sm-5 offset-sm-7">
                                    <div class="col">
                                        <div class="dataTables_paginate paging_simple_numbers float-right">
                                            <ul class="pagination pagination-rounded mb-0">
                                                <pagination
                                                    :data="paginations"
                                                    :limit="limit"
                                                    @pagination-change-page="getSupllier"
                                                ></pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchasingPricesView
            v-if="showModal"
            :supplierdata="supplierData"
            :subProductId="subProductId"
            @actionChanged="$emit('refreshData')"
             @hidden="handleModalHidden"
            />
    </Layout>
</template>